import React from 'react'
import { withRouter } from 'react-router-dom'

import Heading from './Heading'

const HeadingContainer = ({ location }) => (
  <div>
    { location.hash === '#signin' || location.hash === '#forgot-password' ? (
      <Heading>
        Login to your arthaus.
      </Heading>
    ) : (
      <Heading>
        Join to start selling your artwork alongside talented artists the
        world over.
      </Heading>
    ) }
  </div>
)

export default withRouter(HeadingContainer)



// WEBPACK FOOTER //
// ./src/containers/Home/Heading/index.js